import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ITBQuoteSelectProductsComponent } from '../itb-quote-select-products/itb-quote-select-products.component';
import { ITBQuoteEditConfirmBidComponent } from '../itb-quote-edit-confirm-bid/itb-quote-edit-confirm-bid.component';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { NgClass, NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AllowNegativeDecimalNumber, CopyDirective } from '../two-digit-decima-number.directive';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-itb-quote-edit-bid',
    templateUrl: './itb-quote-edit-bid.component.html',
    styleUrls: ['./itb-quote-edit-bid.component.scss'],
    imports: [NgClass, NgIf, FormsModule, NgFor, AllowNegativeDecimalNumber, CopyDirective, DecimalPipe, DatePipe, I18nModule]
})
export class ITBQuoteEditBidComponent implements OnInit {
  private modalRef: NgbModalRef;
  div1:boolean=true;
  activeTab = 'none';
  priceTab= 'none';
  COI: boolean =false;
  ITB: boolean= false;
  OpenNegotiation:boolean=true;
  @Input() code: any;
  @Input() price:number;
  @Input() indexPrice:number;
  @Input() tabName: any;
  @Input() index:any;
  @Input() indexValue: any;
  @Input() parameter=[];
  productInfo:any;
  Info:any;
  priceVal: any;
materialFixedPrice1:any;
materialIndexPrice1:any;
  materialIndex=1;
  InitialValue: number;
  FinalValue: number;
  InitialActive: boolean;
  FinalActive: boolean;
  checkbox:any
  @Input() dischargePortshw:any;
  @Input() quantityshw:any;
  PriceEmpty:boolean =false;
  defaultValue=null;
  displayFixedQPSection = false;
  constructor(public activeModal: NgbActiveModal,
    private Modal:NgbModal,public ActiveModal: NgbActiveModal,public ModalService:NgbModal,
    private modalService: NgbModal,public CustomProductsService:CustomProductsService) { }

  ngOnInit(): void {
    console.log(this.indexValue);
    this.materialFixedPrice1=this.price;
    this.materialIndexPrice1=this.indexPrice;
    this.productInfo=this.code.quoteEntries[this.indexValue];
    this.Info=this.code;
    if(this.indexValue>0){
      this.InitialValue = this.indexValue;
      this.FinalValue = this.indexValue+1;
      this.FinalActive = true;
      this.InitialActive = false;
      
    }else{
      this.InitialValue = 1;
      this.FinalValue = 2;
      this.InitialActive = true;
      this.FinalActive = false;
    }
    this.activeTab = this.tabName ? this.tabName : 'none';
    this.priceTab = this.tabName ? this.tabName : 'none';
   
  }
  checkPriceValidation($event){
    // tslint:disable-next-line:prefer-const
    let s = $event.target.value.split('.');
    if (s.length === 1){
      if (s[0].length >= 6) {
        $event.preventDefault();
      }
    }
  }
changeTab(data):any{
  this.activeTab = data;
  if (this.activeTab === 'FIXED_PRICE') {
    this.priceTab = 'FIXED_PRICE'
  }
  else if (this.activeTab === 'INDEX_PRICE') {
    this.priceTab = 'INDEX_PRICE'
  }
}
  close(): any {
    this.ActiveModal.close();
  }
  checkpriceEnteredorNot(){
  
    if(this.materialFixedPrice1==0||this.materialFixedPrice1==undefined  ){
      this.PriceEmpty = true;
    }
    else{
      this.PriceEmpty = false;
    }
    return this.PriceEmpty
  }
  Openmodal(){
    console.log('indexVal............',this.indexValue,this.code.quoteEntries);
    
    if(this.indexValue === this.code.quoteEntries.length-1){
      let proceedFurther:boolean = this.checkpriceEnteredorNot();
      if(!proceedFurther){
        this.ActiveModal.close();
        const ModalRef = this.modalService.open(ITBQuoteEditConfirmBidComponent,{centered: true,size:'md'});
        ModalRef.componentInstance.multipleProduct=this.Info;
        ModalRef.componentInstance.parameter = this.index;
        ModalRef.componentInstance.indexValue=this.indexValue;
        ModalRef.componentInstance.dischargePortshw = this.dischargePortshw;
        ModalRef.componentInstance.quantityshw = this.quantityshw;
        if(this.productInfo){
            this.code.quoteEntries[this.indexValue].tcPrice.value = this.materialFixedPrice1;
            ModalRef.componentInstance.materialFixedPrice1=this.code.quoteEntries[this.indexValue].tcPrice.value;
             this.code.quoteEntries[this.indexValue].rcPrice.value = this.materialIndexPrice1;
            ModalRef.componentInstance.materialIndexPrice1=this.code.quoteEntries[this.indexValue].rcPrice.value;
      } 
      }
      
  }
  else{
    this.defaultValue = null;
    let proceedFurther:boolean = this.checkpriceEnteredorNot();
    if(!proceedFurther){
      if (this.index.length > 2 && this.indexValue!= this.index.length-1) {
        this.InitialValue = this.indexValue + 1;
        this.FinalValue = this.InitialValue + 1;
        this.InitialActive = true;
        this.FinalActive = false;
      }
      else {
        this.InitialActive = false;
        this.FinalActive = true;
      }
      console.log(this.code);
    this.code.quoteEntries[this.indexValue].tcPrice.value = this.materialFixedPrice1;
    if(this.code.quoteEntries[this.indexValue].displayRCPriceConfig.displayRCPrice==true){
      this.code.quoteEntries[this.indexValue].rcPrice.value = this.materialIndexPrice1;
    }
      this.indexValue = this.indexValue +1;
      this.productInfo = this.code.quoteEntries[this.indexValue];
      this.materialFixedPrice1=  this.code.quoteEntries[this.indexValue].tcPrice.value ;
      if(this.code.quoteEntries[this.indexValue].displayRCPriceConfig.displayRCPrice==true){
      this.materialIndexPrice1=  this.code.quoteEntries[this.indexValue].rcPrice.value ;
      }
    }
   
  }
  }
  backToPlacebid(): any{
    if(this.indexValue<=0){      
      this.ActiveModal.close();
      const ModalRef = this.Modal.open(ITBQuoteSelectProductsComponent,{centered: true,size:'md'});
      ModalRef.componentInstance.productsInfo = this.Info;
           console.log('info.............',this.Info);
           
     this.checkbox=this.code && this.code.quoteEntries;
     this.checkbox.map(val=>{
         val.checked = true;
         ModalRef.componentInstance.parameter = this.index;
         console.log(this.index);
     })
     if(this.productInfo.pricingOptionsEnum[0]?.qp){
      ModalRef.componentInstance.defaultValue = this.productInfo?.pricingOptionsEnum[0]?.qp[0]?.description;
      if(ModalRef.componentInstance.defaultValue == 'Fixed QP'){
        ModalRef.componentInstance.displayFixedQPSection = true;
        ModalRef.componentInstance.finalQPFromDate= ModalRef.componentInstance.productInfo.finalQPFromDate;
        ModalRef.componentInstance.finalQPToDate= ModalRef.componentInstance.productInfo.finalQPToDate;
      }else{
        ModalRef.componentInstance.displayFixedQPSection = false;
      }
    }
    }else{
      console.log('inelse');
      
      if(this.indexValue==1){
        this.FinalValue = 2;
        this.InitialValue = 1;
        this.InitialActive = true;
        this.FinalActive = false;
      }
      else{
        this.FinalValue = this.FinalValue-1;
        this.InitialValue = this.InitialValue-1;
      }
      this.indexValue = this.indexValue -1;
      this.productInfo = this.code.quoteEntries[this.indexValue];
      console.log(this.productInfo);
      this.defaultValue = this.productInfo?.pricingOptionsEnum[0]?.qp[0]?.description;                     
      if(this.code.quoteEntries[this.indexValue].pricingOptionsEnum[0]?.qp){
      this.defaultValue = this.productInfo.pricingOptionsEnum[0]?.qp[0]?.description;
      if(this.productInfo.defaultValue == 'Fixed QP'){
        this.productInfo.displayFixedQPSection = true;
        this.productInfo.finalQPFromDate= this.code.quoteEntries[this.indexValue].finalQPFromDate;
        this.productInfo.finalQPToDate= this.code.quoteEntries[this.indexValue].finalQPToDate;
      }else{
        this.productInfo.displayFixedQPSection = false;
      }
     }
        this.priceTab=this.code.quoteEntries[this.indexValue].priceTab;
          this.materialFixedPrice1= this.code.quoteEntries[this.indexValue].tcPrice.value;
           this.materialIndexPrice1= this.code.quoteEntries[this.indexValue].rcPrice.value;
           
    }

   
  }
  qpChangeAction(event:any, options:any){   
    options.pricingOptionsEnum[0].qp=[];    
    if(event.target.value === 'Fixed QP'){     
      this.displayFixedQPSection = true;
    }else{
      this.displayFixedQPSection = false;
    }
    let valueSelected = options.pricingOptionsEnum[0].qpMultipleChoices.find(x=>x.description == event.target.value);
    
    options.pricingOptionsEnum[0].qp.push(valueSelected);
    // options.qp.push({"description": event.target.value, "uniqueRowNumber":event.currentTarget.options[event.currentTarget.options.selectedIndex].id})
  }
  omit_special_char(event){   
    var k;  
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k==46 ||(k >= 48 && k <= 57)); 
   }
   divide(){
    
    if(!isNaN(this.materialFixedPrice1)){
      //this.materialFixedPrice1 = Math.abs(this.materialFixedPrice1)
      this.materialIndexPrice1= (this.materialFixedPrice1/ 1000);
      this.materialIndexPrice1 = Number(this.materialIndexPrice1.toFixed(5));
    }
    else{
      this.materialFixedPrice1 = null;
      this.materialIndexPrice1 = null;
    }
    console.log('index',this.indexPrice)
  }
  getDate(date){
    if(date){
      var formateDate = new Date(date).getDate() + '/' + (new Date(date).getMonth() + 1) + '/' + new Date(date).getFullYear();
      return formateDate;
    }
    else{
      return '';
    }

  }
  formatQPDates(data){
    return this.CustomProductsService.formatQPDates(data);
  }
}
